import { useEffect, useState } from "react";

export default function HealthCheck() {
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    if (window.APP_HEALTH === "ok") {
      setStatus("healthy");
    } else {
      setStatus("unhealthy");
    }
  }, []);

  return (
    <div>
      FRONTEND_STATUS:{status}
    </div>
  );
}